import { render, staticRenderFns } from "./tileCatalog-item.vue?vue&type=template&id=3ab4a736&scoped=true&"
import script from "./tileCatalog-item.vue?vue&type=script&lang=js&"
export * from "./tileCatalog-item.vue?vue&type=script&lang=js&"
import style0 from "./tileCatalog-item.vue?vue&type=style&index=0&id=3ab4a736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab4a736",
  null
  
)

export default component.exports